import * as React from 'react';
import { RootState } from '../../../store/index';
import { connect } from 'react-redux';
import {
  TreeNodeType,
  TreeType,
  TreeDisplayStateType,
  ParamSysName,
  getSelectedGeofence,
  GeofenceEditData,
  getCheckedNodesIds,
} from 'features/FMTree';
import {
    expandParentsAndSelectNode,
    updateGeofenceEditNodePoints,
    replaceHasChanged,
} from '../../../store/FMTree/FMTreeActions';
interface OwnProps {
  fortMap: any;
}
interface DispatchProps {
  expandParentsAndSelectNode: (
    treeType: TreeType,
    treeDisplayState: TreeDisplayStateType,
    nodeType: TreeNodeType,
    id: string
  ) => void;
  updateGeofenceEditNodePoints: (displayState: TreeDisplayStateType, points: any[]) => void;
  replaceHasChanged: any;
}

interface StateProps {
  geofencesByIds: any;
  selectedGeofenceId: string;
  geofencesAllIds: string[];
  geofenceInEditMode: boolean;
  nodeEditData: GeofenceEditData;
  checkedGeofencesIds: string[];
  isOptimizing: boolean;
}


type Props = OwnProps & StateProps & DispatchProps;

class FMMap extends React.Component<Props> {
  private geoService: any;

  constructor(props: Props) {
    super(props);
    this.geoService = props.fortMap.geoService;

    document.addEventListener('ShowOnlyCheckedGeofencesChanged', (event: any) => {
      showOnlyCheckedGeofences = event.detail;
      let checkedByIds = this.getCheckedOrSelectedOnly(this.props.geofencesByIds, this.props);
      if (showOnlyCheckedGeofences) {
        this.geoService.deleteGeofences(this.props.geofencesAllIds);
        this.geoService.addNewGeofencesToExistingLayer(checkedByIds);
      }
      else {
        let checkedIds = this.getIds(checkedByIds);
        this.geoService.deleteGeofences(checkedIds);
        this.geoService.addNewGeofencesToExistingLayer(this.props.geofencesByIds);
      }
    });
  }

  public componentDidMount() {
    this.geoService.setGeofences(this.props.geofencesByIds, this.selectGeofence);
  }

  private constructDataForEditedGeofence(geofenceEditData: GeofenceEditData, color = '') {
    let geofenceData = {
      type: geofenceEditData.geofenceType,
      id: geofenceEditData.id,
      name: '',
      dataForMap: {
        points: geofenceEditData.points,
        color: color,
        icon: '',
        radius: null,
        showOnMap: true
      },
      dataForTree: {
        parentId: null
      }
    };

    for (let param of geofenceEditData.params) {

      switch (param.sysName) {
        case ParamSysName.name:
          geofenceData.name = param.value;
          break;
        case ParamSysName.color:
          geofenceData.dataForMap.color = param.value;
          break;
        case ParamSysName.radius:
          geofenceData.dataForMap.radius = param.value;
          break;
        case ParamSysName.icon:
          geofenceData.dataForMap.icon = param.value;
          break;
        case ParamSysName.showOnMap:
          geofenceData.dataForMap.showOnMap = param.value;
          break;
      }
    }
    return geofenceData;
  }

  public selectGeofence = async (geofenceId: string) => {
    return await this.props.expandParentsAndSelectNode(
      TreeType.geofencesTree,
      TreeDisplayStateType.mainGeofencesTree,
      TreeNodeType.item,
      geofenceId
    );
  }

  private getDeletedGeofences(nextProps: Props) {
    if (nextProps.geofencesAllIds !== this.props.geofencesAllIds) {
      const deletedGeofences = this.props.geofencesAllIds.filter(x => !nextProps.geofencesAllIds.includes(x));
      return deletedGeofences;
    }
    return [];
  }

  private getNewGeofencesIds(nextProps: Props) {
    if (nextProps.geofencesAllIds !== this.props.geofencesAllIds) {
      const newGeofences = nextProps.geofencesAllIds.filter(x => !this.props.geofencesAllIds.includes(x));
      return newGeofences;
    }
    return [];
  }

  private getNewGeofences(nextProps: Props, newGeofenceIds: string[]) {
    const newGeofencesByIds = {};
    for (let id of newGeofenceIds) {
      newGeofencesByIds[id] = nextProps.geofencesByIds[id];
    }
    return newGeofencesByIds;
  }

  private isChangeGeofences(nextProps: Props) {
      return this.props.geofencesByIds !== nextProps.geofencesByIds;
  }

  private isStartEditGeofence(nextProps: Props) {

    return nextProps.nodeEditData !== null &&
          nextProps.nodeEditData.geofenceType !== undefined &&
          nextProps.geofenceInEditMode !== this.props.geofenceInEditMode &&
          nextProps.geofenceInEditMode;
  }

  private isFinishEditGeofence(nextProps: Props) {
    return nextProps.geofenceInEditMode !== this.props.geofenceInEditMode && nextProps.nodeEditData.geofenceType !== undefined && !nextProps.geofenceInEditMode;
  }

  private isUpdateEditingGeofence(nextProps: Props) {
    return nextProps.nodeEditData !==null && nextProps.nodeEditData.geofenceType !== undefined && nextProps.geofenceInEditMode === this.props.geofenceInEditMode &&
    nextProps.geofenceInEditMode &&
    nextProps.nodeEditData !== this.props.nodeEditData;
  }

  private getChangedGeofencesByIds(nextProps: Props) {
      let changedGeofencesByIds = {};
      for (let id in nextProps.geofencesByIds) {
        if (nextProps.geofencesByIds[id] && this.props.geofencesByIds[id]
          && nextProps.geofencesByIds[id] !== this.props.geofencesByIds[id]
        ) {
          changedGeofencesByIds[id] = nextProps.geofencesByIds[id];
        }
      }
      return changedGeofencesByIds;
  }

  private getCheckedOrSelectedOnly(geofencesByIds, props) {
    let result = {};
    for (let id in geofencesByIds) {
      if (props.checkedGeofencesIds.includes(id) || props.selectedGeofenceId === id) {
        result[id] = geofencesByIds[id];
      }
    }
    return result;
  }

  private getIds(geofencesByIds) {
    let result = [];
    for (let id in geofencesByIds) {
      result.push(id);
    }
    return result;
  }
  
  private onChangeGeofencePoints = (points) => {
    this.props.updateGeofenceEditNodePoints(TreeDisplayStateType.mainGeofencesTree, points);
    this.props.replaceHasChanged(true);
  }

  public shouldComponentUpdate(nextProps: Props) {
    if (showOnlyCheckedGeofences) {
      let currentCheckedIds = [...this.props.checkedGeofencesIds];
      let nextCheckedIds = [...nextProps.checkedGeofencesIds];
      let currentSelectedId = this.props.selectedGeofenceId;
      let nextSelectedId = nextProps.selectedGeofenceId;
      if (currentSelectedId && !currentCheckedIds.includes(currentSelectedId)) {
        currentCheckedIds.push(currentSelectedId);
      }
      if (nextSelectedId && !nextCheckedIds.includes(nextSelectedId)) {
        nextCheckedIds.push(nextSelectedId);
      }

      let newCheckedIds = nextCheckedIds.filter(x => !currentCheckedIds.includes(x));
      let newUncheckedIds = currentCheckedIds.filter(x => !nextCheckedIds.includes(x));
      if (newCheckedIds.length > 0) {
        let newCheckedByIds = {};
        for (let id of newCheckedIds) {
          newCheckedByIds[id] = nextProps.geofencesByIds[id];
        }
        this.geoService.addNewGeofencesToExistingLayer(newCheckedByIds);
      }
      if (newUncheckedIds.length > 0) {
        this.geoService.deleteGeofences(newUncheckedIds);
      }
    }

    const deletedGeofences = this.getDeletedGeofences(nextProps);

    if (deletedGeofences.length > 0) {
      this.geoService.deleteGeofences(deletedGeofences);
    }

    if (this.isStartEditGeofence(nextProps)) {
      this.geoService.startEditGeofence(
        this.constructDataForEditedGeofence(nextProps.nodeEditData, 'grey'),
        this.onChangeGeofencePoints,
        nextProps.isOptimizing
      );
      return false;
    }

    if (this.isFinishEditGeofence(nextProps)) {
      this.geoService.finishEditGeofence();
    }

    if (this.isUpdateEditingGeofence(nextProps)) {
        this.geoService.updateEditingGeofence(this.constructDataForEditedGeofence(nextProps.nodeEditData));
    }

    const newGeofenceIds = this.getNewGeofencesIds(nextProps);

    if (newGeofenceIds.length > 0) {
      let newGeofencesByIds = this.getNewGeofences(nextProps, newGeofenceIds);
      let filteredGeofences = showOnlyCheckedGeofences
        ? this.getCheckedOrSelectedOnly(newGeofencesByIds, nextProps)
        : newGeofencesByIds;
      this.geoService.addNewGeofencesToExistingLayer(filteredGeofences);
    }

    if (this.isChangeGeofences(nextProps)) {
      let changedGeofencesByIds = this.getChangedGeofencesByIds(nextProps);
      let changeGeofencesAllIds = Object.keys(changedGeofencesByIds);
      this.geoService.deleteGeofences(changeGeofencesAllIds);
      let filteredGeofences = showOnlyCheckedGeofences
        ? this.getCheckedOrSelectedOnly(changedGeofencesByIds, nextProps)
        : changedGeofencesByIds;
      this.geoService.addNewGeofencesToExistingLayer(filteredGeofences);
    }

    return false;

  }

  public render() {
    return null;
  }

}

const mapStateToProps = (state: RootState): StateProps => ({
  geofencesByIds: state.fmTrees.fmTreesData[TreeType.geofencesTree][TreeNodeType.item].byIds,
  geofencesAllIds: state.fmTrees.fmTreesData[TreeType.geofencesTree][TreeNodeType.item].allIds,
  selectedGeofenceId: getSelectedGeofence(state, TreeDisplayStateType.mainGeofencesTree),
  geofenceInEditMode: state.fmTrees.fmTreesDisplay[TreeDisplayStateType.mainGeofencesTree].infoPanelInEditMode,
  nodeEditData: state.fmTrees.fmTreesDisplay[TreeDisplayStateType.mainGeofencesTree].nodeEditData as GeofenceEditData,
  checkedGeofencesIds: getCheckedNodesIds(state, TreeDisplayStateType.mainGeofencesTree, TreeNodeType.item),
  isOptimizing: state.fmTrees.fmTreesDisplay[TreeDisplayStateType.mainGeofencesTree].infoPanelInOptimizeMode,
});

const mapDispatchToProps = {
  expandParentsAndSelectNode,
  updateGeofenceEditNodePoints,
  replaceHasChanged,
};

export default connect(mapStateToProps, mapDispatchToProps)(FMMap);
